"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const cache_1 = __importDefault(require("@emotion/cache"));
const react_2 = require("@emotion/react");
const EmotionWrapper = (props) => {
    const divRef = (0, react_1.useRef)(null);
    const { children, shadowRoot } = props;
    const [divCurrent, setDivCurrent] = (0, react_1.useState)();
    // note: in order for you to use fonts. they need to
    // be loaded on the top level and inside the shadow
    // the shadow dom can insert the stylesheet
    // while the top level / index.html loads the otf files ( fonts )
    const addExternalStyles = (0, react_1.useCallback)((attributes) => {
        const linkEl = document.createElement('link');
        Object.assign(linkEl, attributes);
        if (shadowRoot) {
            shadowRoot.append(linkEl);
        }
    }, [shadowRoot]);
    (0, react_1.useEffect)(() => {
        if (!divCurrent && (divRef === null || divRef === void 0 ? void 0 : divRef.current)) {
            setDivCurrent(divRef.current);
            addExternalStyles({
                id: 'iress-icon-fonts',
                rel: 'stylesheet',
                href: 'https://cdn.iress.com/icons/5.15.4/css/combined.min.css',
                integrity: 'sha384-O0tKAkjAKb3hzzRO6Q+3v+zLDboFGyCPSPFzMbNdv4weAM/UF5hCJua1gLIjRbXP',
                crossOrigin: 'anonymous',
            });
        }
    }, [divCurrent, divRef, addExternalStyles]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ ref: divRef }, { children: (0, jsx_runtime_1.jsx)(react_2.CacheProvider, Object.assign({ value: (0, cache_1.default)({
                key: 'iress-hijack-ui-styles',
                prepend: true,
                container: divCurrent,
            }) }, { children: children })) })));
};
exports.default = EmotionWrapper;
